import localimgpath from "../../js/localimgpath";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa";
import { RiTwitterXLine } from "react-icons/ri";
import {
  Animatespin,
  MainHeading,
  Footer,
  Navbar,
} from "../../components/index";
import Functions from "./index.function";
const SingleTeam = () => {
  const { isLoading, TheATeamData, TheATeamColorsData, flagUrl } = Functions();

  return (
    <div className="bg-primary h-screen scroll-container">
      <Navbar />
      <div className=" xs:px-3 m-auto xs:pb-5 sm:px-5 lg:px-5 xl:px-10 sm:pb-8 lg:pb-14">
        <MainHeading
          title={"Member Detail"}
          layout={"h-18 sm:h-20 lg:h-36"}
          navigate={"/team"}
        />
        {isLoading ? (
          <Animatespin />
        ) : (
          <>
            {TheATeamData ? (
              <div className="flex xs:flex-col justify-start items-center">
                <div className="xs:w-full sm:w-2/6 flex justify-center items-center xs:mb-6">
                  <div
                    className={`overflow-hidden xs:w-[296px] xs:h-[373px] sm:w-[310px] sm:h-[350px] lg:w-[350px] lg:h-[410px] xl:w-[400px] xl:h-[510px] 2xl:w-[450px] 2xl:h-[570px] xs:rounded-[43px] sm:rounded-[45px] lg:rounded-[58px] xl:rounded-[65px]`}
                    style={{ backgroundColor: TheATeamColorsData }}
                  >
                    <img
                      src={`${localimgpath.teamAvatar}/${TheATeamData?.avatar}`}
                      alt={TheATeamData?.name}
                      className="w-full h-full"
                    />
                  </div>
                </div>
                <div className="xs:w-full sm:w-4/6 sm:px-3 lg:px-7">
                  <h2 className="text-secondary font-onestBold xs:text-lg lg:text-3xl xl:text-4xl xs:mb-1 sm:mb-2 lg:mb-3">
                    {TheATeamData?.name}
                  </h2>
                  <div className="flex justify-start items-end xs:mb-1 sm:mb-2 lg:mb-3 xs:gap-x-3 sm:gap-x-4 lg:gap-5">
                    <p className="text-secondary  font-onestMedium xs:!text-[13px] lg:text-lg xl:text-xl leading-3">
                      {`${TheATeamData?.designation?.name ?? ""} - ${
                        TheATeamData?.city?.city ?? ""
                      }. ${TheATeamData?.country?.country ?? ""}`}
                    </p>
                    <img
                      src={flagUrl}
                      className="w-5 h-5 sm:w-10 sm:h-8 lg:mb-1.5 rounded-sm sm:rounded-[3px]"
                      alt={TheATeamData?.country?.country}
                    />
                  </div>
                  <p className="text-[#707070] xs:text-xs">
                    {TheATeamData?.description}
                  </p>
                  <div className="flex items-start justify-center flex-col">
                    <div className="flex space-x-4 xs:mb-3 xs:pt-3 sm:pt-3 lg:pt-6">
                      {TheATeamData?.social_media_links?.map((item, index) => {
                        const { social_media_type, social_media_link } = item;

                        if (!social_media_link) return null;

                        switch (social_media_type) {
                          case "facebook":
                            return (
                              <a
                                key={index}
                                href={social_media_link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="bg-[#1877F2] text-secondary rounded-full cursor-pointer xs:w-7 xs:h-7 sm:w-6 sm:h-6 lg:w-8 lg:h-8 xl:w-10 xl:h-10 flex justify-center items-end transition-all duration-300 transform hover:scale-110 hover:bg-[#1877F2cb]"
                              >
                                <FaFacebookF className="xs:text-xl sm:text-lg lg:text-2xl xl:text-3xl" />
                              </a>
                            );

                          case "instagram":
                            return (
                              <a
                                key={index}
                                href={social_media_link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-secondary rounded-full cursor-pointer xs:w-7 xs:h-7 sm:w-6 sm:h-6 lg:w-8 lg:h-8 xl:w-10 xl:h-10 flex justify-center items-center transition-all duration-300 transform hover:scale-110 hover:shadow-lg gradient-container"
                              >
                                <FaInstagram className="xs:text-base lg:text-xl sm:text-sm xl:text-2xl" />
                              </a>
                            );

                          case "linkedin":
                            return (
                              <a
                                key={index}
                                href={social_media_link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="bg-[#0B69C7] text-secondary rounded-full cursor-pointer xs:w-7 xs:h-7 sm:w-6 sm:h-6 lg:w-8 lg:h-8 xl:w-10 xl:h-10 flex justify-center items-center transition-all duration-300 transform hover:scale-110 hover:shadow-lg hover:bg-[#084D93cb]"
                              >
                                <FaLinkedinIn className="xs:text-base sm:text-sm lg:text-lg xl:text-xl" />
                              </a>
                            );

                          case "twitter":
                            return (
                              <a
                                key={index}
                                href={social_media_link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="bg-black text-secondary rounded-full cursor-pointer xs:w-7 xs:h-7 sm:w-6 sm:h-6 lg:w-8 lg:h-8 xl:w-10 xl:h-10 flex justify-center items-center transition-all duration-300 transform hover:scale-110 hover:shadow-lg hover:bg-[#0A95D0cb]"
                              >
                                <RiTwitterXLine className="xs:text-sm sm:text-sm lg:text-lg xl:text-xl" />
                              </a>
                            );

                          case "youtube":
                            return (
                              <a
                                key={index}
                                href={social_media_link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="bg-[#F20000] text-secondary rounded-full cursor-pointer xs:w-7 xs:h-7 sm:w-6 sm:h-6 lg:w-8 lg:h-8 xl:w-10 xl:h-10 flex justify-center items-center transition-all duration-300 transform hover:scale-110 hover:shadow-lg hover:bg-[#d90000cb]"
                              >
                                <FaYoutube className="xs:text-base lg:text-xl sm:text-base xl:text-2xl" />
                              </a>
                            );

                          default:
                            return null;
                        }
                      })}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <p className="text-secondary font-onestSemiBold">
                No team member selected
              </p>
            )}
          </>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default SingleTeam;
